<template>
    <div class="container-fluid">
        <div v-for="(item, index) of requests" :key="index">
            <div class="superkid-request">
                <div class="row align-items-center">
                    <div class="col-md-6">
                        <div>
                            <p> <span>{{item.parent.firstname}} {{item.parent.lastname}}</span> wants to add you as the child's coach for superkid challenge.</p>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="request-btn">
                            <button class="btn accept" @click="respondtoRequest(item, 'accepted'); action = 'accepted'" >
                                Accept
                                <i
                                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                    v-if="requestLoading && item.id && action == 'accepted'"
                                    >
                                </i>
                            </button>
                            <button class="btn reject" @click="respondtoRequest(item, 'rejected'); action = 'rejected'">
                                Reject
                                <i
                                    class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader"
                                    v-if="requestLoading && item.id && action == 'rejected'"
                                    >
                                </i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Service } from "../store/service";
const Api = new Service();


export default {
  name: "CoachRequest",
  components: {
  },

  data() {
    return {
        requests: [],
        requestLoading: false,
        action: ""
    };
  },
  created() {
   
  },
  mounted() {
    this.fetchCoachRequest();
  },
  methods: {
    async fetchCoachRequest() {
      try {
        await Api.getRequest(`fetch-pending-coach-request`).then(res => {
          if (res.data.success) {
            this.requests = res.data.data;
          }
        }).catch(err => {
          console.log("Error", err)
        })
      } finally {
        // console.log("closed")
      }
    },
    async respondtoRequest(item, action) {
        this.requestLoading = true;
        try {
            await Api.postRequest("respond-to-pending-coach-request", {request_id: item.id, response: action}).then(res => {
                this.requestLoading = false;
                if (res.data.success) {
                    this.fetchCoachRequest();
                    return this.$store.commit("setApiSuccess", res.data.success);
                }
                if (res.data.error) {
                    return this.$store.commit("setApiFailed", res.data.error);
                }
            }).catch(err => {
                consol.log("Error:", err);
                this.requestLoading = false;
            })
        } finally {
            // console.log("closed")
        }
    }
  }
};
</script>


<style scoped lang="scss">
    .superkid-request {
        background-color: #ffffff;
        padding: 15px 15px;
        margin-top: 0.5rem;
        width: 100%;
        align-items: baseline;
        // text-align: left;
        p {
            margin-bottom: 0;
            font-family: Lato;
            font-size: 16px;
            text-align: left;
        }
        span {
            font-weight: 600;
        }
        .request-btn {
            text-align: right;
            button {
                font-family: Lato;
                font-weight: 600;
                font-size: 14px;
                outline: 0;
                box-shadow: none;
            }
            .accept {
                background: #0033EA;
                color: #ffffff;
                margin-right: 10px;
            }
            .reject {
                border: 1px solid #0033EA;
                color: #0033EA;
            }
        }
    }

    @media only screen and (max-width: 599px) {
        .request-btn {
            text-align: center !important;
            margin-top: 30px;
        }
    }
</style>